export default __webpack_public_path__ + "static/media/delhiCityTakeover.ecccf946.png";